import {
  // AfterContentInit,
  AfterViewInit,
  Component,
  // EventEmitter,
  inject,
  OnInit,
  // Output,
  ViewChild,
} from '@angular/core';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UploadShapefileComponent } from '../../../shared/components/upload-shapefile/upload-shapefile.component';
import { CommonModule } from '@angular/common';
// import { MatError } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { SmartOrpcClientService } from '../../../shared/services/smart-orpc-client.service';
import { EnhancedLoadingService } from '../../../shared/services/enhanced-loading.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarService } from '../../../shared/services/snackbar.service';

@Component({
  selector: 'app-monitoring-plot-upload',
  templateUrl: './monitoring-plot-upload.component.html',
  styleUrls: ['./monitoring-plot-upload.component.scss'],
  imports: [
    CommonModule,
    //MatError,
    MatIconModule,
    MatButtonModule,
    UploadShapefileComponent,
    MatProgressSpinnerModule,
  ],
})
export class MonitoringPlotUploadComponent implements AfterViewInit, OnInit {
  private orpc = inject(SmartOrpcClientService);
  private loadingService = inject(EnhancedLoadingService);
  private snackBar = inject(SnackbarService);
  @ViewChild('shapefileUpload')
  declare shapefileUploadComponent: UploadShapefileComponent;

  shapefileName: string | null = null;
  fileSeedId?: number;

  // Estado de validação
  isValidating = false;
  validationErrors: string[] = [];
  isValidFile = false;
  hasValidated = false;

  shapefileTypes: string = [
    '.shp',
    '.zip',
    'application/zip',
    'application/x-zip-compressed',

    'application/octet-stream',
  ].join(',');

  get shapefileHasError() {
    return (
      this.shapefileUploadComponent?.fileCtrl?.hasError(
        'shapefileValidation',
      ) || false
    );
  }

  get shapefileErrorMessage() {
    return (
      this.shapefileUploadComponent?.fileCtrl?.getError(
        'shapefileValidation',
      ) || {}
    );
  }

  // Getter para verificar se o arquivo está pronto para upload
  get canSubmit(): boolean {
    return !!(
      this.shapefileName &&
      this.hasValidated &&
      this.isValidFile &&
      !this.shapefileHasError &&
      !this.isValidating
    );
  }

  // Getter para mostrar os erros de validação
  get hasValidationErrors(): boolean {
    return this.validationErrors.length > 0;
  }
  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit() {
    this.fileSeedId = Number(this.route.snapshot.paramMap.get('id'));
  }
  ngAfterViewInit(): void {
    console.log(this.shapefileUploadComponent);
  }

  async onSubmit() {
    try {
      if (this.shapefileUploadComponent.fileCtrl.invalid) {
        this.snackBar.alert(
          'Por favor, corrija os erros no arquivo antes de prosseguir.',
        );
        return;
      }

      if (!this.fileSeedId) {
        this.snackBar.alert('ID do arquivo semente não encontrado.');
        return;
      }

      // Verificar se o arquivo foi validado e é válido
      if (!this.hasValidated) {
        this.snackBar.alert('Aguarde a validação do arquivo ser concluída.');
        return;
      }

      if (!this.isValidFile) {
        this.snackBar.alert(
          'O arquivo não passou nas validações. Corrija os problemas antes de prosseguir.',
        );
        return;
      }

      this.loadingService.show('button');
      const result = await this.orpc.client.monitoring.plotHistory.upload(
        {
          fileSeedId: this.fileSeedId,
          fileName: this.shapefileName!,
        },
        { context: { errorMessage: 'Erro no upload do arquivo de talhões' } },
      );

      if (result.uploaded) {
        this.snackBar.alert('Arquivo de talhões enviado com sucesso!');
        this.navigateToRequestScreen();
      } else {
        this.snackBar.alert('Erro no upload do arquivo de talhões', -1);
      }
    } catch (error) {
      console.error('Erro no upload:', error);
    } finally {
      this.loadingService.hide('button');
    }
  }
  isLoading() {
    return this.loadingService.button$;
  }

  get isAnyLoading(): boolean {
    return this.isValidating;
  }
  onCancel() {
    this.navigateToDetailScreen();
  }

  private navigateToDetailScreen() {
    this.router.navigate(['/monitoring-safras']);
  }
  private navigateToRequestScreen() {
    this.router.navigate(['/monitoring-safras']);
  }
  onFileUploaded($event: string | null) {
    this.shapefileName = $event;

    // Reset validation state
    this.hasValidated = false;
    this.isValidFile = false;
    this.validationErrors = [];

    // Trigger validation after file upload
    if (this.shapefileName) {
      this.validateUploadedFile();
    }
  }

  /**
   * Executa as validações RN5.12-002 e RN5.12-003 após o upload do arquivo
   */
  async validateUploadedFile() {
    if (!this.shapefileName || !this.fileSeedId) {
      return;
    }

    try {
      this.isValidating = true;
      this.validationErrors = [];

      // Chamar o endpoint de validação
      const result = await this.orpc.client.monitoring.plotHistory.validate(
        {
          fileSeedId: this.fileSeedId,
          fileName: this.shapefileName,
        },
        {
          context: {
            errorMessage: 'Erro interno durante a validação do arquivo',
          },
        },
      );

      this.isValidFile = result.isValid;
      this.validationErrors = result.errors;
      this.hasValidated = true;

      if (!result.isValid) {
        // Mostrar erros específicos
        result.errors.forEach((error) => {
          this.snackBar.alert(error, 8000);
        });
      }
    } catch (error) {
      console.error('Erro na validação do arquivo:', error);
      this.validationErrors = ['Erro interno durante a validação do arquivo'];
      this.isValidFile = false;
      this.hasValidated = true;
    } finally {
      this.isValidating = false;
    }
  }
}
